const ORIGIN_COORDINATE_THRESHOLD = 0.01;
export const DEFAULT_CHECK_COUNTRY_CODE = "DE";


export const normalizeCheckCountryCode = (
    value,
    fallback = DEFAULT_CHECK_COUNTRY_CODE
) => {
    const countryCode = String(value || "").trim().toUpperCase();

    return /^[A-Z]{2}$/.test(countryCode) ? countryCode : fallback;
};

export const normalizeCheckAddress = (value) => String(value || "").trim();


export const toCheckLocationNumber = (value) => {
    if (
        value === null ||
        value === undefined ||
        (typeof value === "string" && !value.trim())
    )
    {
        return null;
    }

    const number = Number(value);

    return Number.isFinite(number) ? number : null;
};

export const isValidCheckLatitude = (value) => {
    const number = toCheckLocationNumber(value);

    return number !== null && number >= -90 && number <= 90;
};

export const isValidCheckLongitude = (value) => {
    const number = toCheckLocationNumber(value);

    return number !== null && number >= -180 && number <= 180;
};

export const hasMeaningfulCheckCoordinates = (latitude, longitude) => {
    if (!isValidCheckLatitude(latitude) || !isValidCheckLongitude(longitude))
    {
        return false;
    }

    const lat = toCheckLocationNumber(latitude);
    const lng = toCheckLocationNumber(longitude);

    return !(
        Math.abs(lat) < ORIGIN_COORDINATE_THRESHOLD &&
        Math.abs(lng) < ORIGIN_COORDINATE_THRESHOLD
    );
};

export const isValidCheckRadius = (value) => {
    const number = toCheckLocationNumber(value);

    return number !== null && number > 0;
};

export const roundCheckCoordinate = (value) => Number(value.toFixed(6));
